import $ from 'jquery';
import { utils } from '../common/utils';

export class DonationProgress {
    private $donationProgress: JQuery<HTMLElement>;
    private currentStep = 1;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$donationProgress = utils.isJquery(element) ? element : $(element);
    }

    get currentElement(): HTMLElement {
        return this.$donationProgress[0];
    }

    get CurrentStep(): number {
        return this.currentStep;
    }

    setProgress(step: number): void {
        this.$donationProgress.children().removeClass('active').removeClass('visited');
        this.currentStep = step;
        const currentIndex = this.currentStep - 1;

        this.$donationProgress.children().each((idx, item) => {
            const $item = $(item);
            if (idx < currentIndex) {
                $item.addClass('visited');
            } else if (idx === currentIndex) {
                $item.addClass('active');
            }
        });
    }
}
